import { defineComponent as _defineComponent } from 'vue'
import {
  PropType,
  ref,
  onMounted,
  nextTick,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXDottedBox',
  props: {
  background: {
    type: String as PropType<'none' | 'white'>,
    default: 'none'
  }
},
  setup(__props) {



// This fixes a bug where the height of the box is not set correctly
// due to the dynamicaly filled slot content.
const ready = ref(false);
onMounted(async () => {
  await nextTick();
  ready.value = true;
});

return { __sfc: true,ready }
}

})